import { ComponentEventBus, inject, prop } from "fw";
import { ChangeEmailAddressRequest, User } from "models/user";
import { ConfirmService } from "service/confirm-service";
import { CancelChangeEmailAction, ResendChangeEmailAction } from "state/users";
import { dispatch } from "fw-state";
import { Notification } from "service/notification";
import { UserStore } from "state/users";
import { CurrentUserStore } from "state/current-user";

@inject
export class PendingEmailAddressDialog {
    @prop(null) userId: string;
    @prop(null) changeEmailAddress: ChangeEmailAddressRequest;

    constructor(
        private ceb: ComponentEventBus,
        private currentUser: CurrentUserStore,
        private confirmService: ConfirmService,
        private notifier: Notification,
        private userStore: UserStore
    ) {}

    public async confirmResendPendingEmailAddress() {
        const confirm = await this.confirmService.confirm({
            title: "Confirm resending change email",
            message: `Are you sure you want to resend confirmation email to <strong>${this.changeEmailAddress.PendingEmailAddress}</strong>?`
        });

        if (!confirm) return;

        try {
            await dispatch(new ResendChangeEmailAction(this.userId));
            this.notifier.notify("Resent confirmation email");
        } catch (error) {
            this.notifier.error("Could not resend confirmation email");
        }
    }

    public async confirmCancelPendingEmailAddress() {
        const confirm = await this.confirmService.confirm({
            title: "Cancel change email",
            message: `Are you sure you want to cancel the change email?`
        });

        if (!confirm) return;

        try {
            const action = new CancelChangeEmailAction(this.userId);
            await dispatch(action);

            this.ceb.dispatch("updated", action.updated);
            this.notifier.notify("Cancelled change email");
        } catch (error) {
            this.notifier.error("Could not cancel change email");
        }
    }

    public get hasPendingEmailAddress(): boolean {
        const { PendingEmailAddress } = this.changeEmailAddress || {};
        return !!PendingEmailAddress;
    }

    public get showResend(): boolean {
        const user = this.getUser(this.userId);
        return user && user.IsActive;
    }

    private getUser(userId: string): User {
        let user = this.userStore.state.collection.find((i) => i.Id == userId);
        if (!user && this.currentUser.state.user.Id === this.userId) {
            user = this.currentUser.state.user;
        }

        return user;
    }
}
